// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.
import React from 'react'
// import { Navigate, Route } from 'react-router-dom'
import { BrowserRouter as Router, Routes, Route , Navigate} from 'react-router-dom';
import { getToken, logout } from '../../services/User';
// import withRouter from 'react-router/withRouter';

const PrivateRoute = ({ component: Component, ...rest }) => {

  // Add your own authentication on the below line.
  function checkLogin() {

    const xToken = getToken();

    if (!xToken) {
      return false;
    }
    return true;
  }
  const isLoggedIn = checkLogin();

  const originalUrl = document.location.pathname;

  return (
      isLoggedIn ? <Component/> : <Navigate to={{ search: `originalUrl=${originalUrl}`, pathname:`/signin` }} />
    )
}

export default PrivateRoute